module.exports = __webpack_public_path__ + "static/img/16.52b1977.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/16.png
// module id = z60K
// module chunks = 0